import { isObject } from "lodash"
import { BROKER_LEVEL_ARRAY, BUSINESS_TYPE_ARRAY, formatDataBrokerDetail, getStatusBrokerObject } from './table'
import moment from "moment"


export const initialValuesBroker = (data: any) => {

  return {
    ...data,
    id: data?.id || null,
    code: data?.code || '',
    full_name: data?.full_name || '',
    avatar: data?.user?.avatar?.url?.medium || '',
    email: data?.user?.email || '',
    phone_number: data?.user?.phone_number || '',
    business_type: BUSINESS_TYPE_ARRAY.find(item => item.code === data?.business_type) || '',
    broker_level: BROKER_LEVEL_ARRAY.find(item => item.code === data?.broker_level) || '',
    profile_image: data?.avatar?.uuid || '',
    address: data?.user?.address || '',
    certificates: data?.certificates || [],
    province_id: data?.user?.province_id || null,
    district_id: data?.user?.district_id || null,
    ward_id: data?.user?.ward_id || null,
    point: data?.point || null,
    manager_code: data?.manager_id ? data?.manager?.code : '',
    manager_id: data?.manager_id || null,
    manager: data?.manager || null,
    zalo: data?.zalo?.data || '',
    facebook: data?.facebook?.data || '',
    tax_id: data?.tax_id || '',
    bank_name: data?.bank_name || '',
    bank_account_name: data?.bank_account_name || '',
    bank_account_number: data?.bank_account_number || '',
    bio: data?.bio || '',
    broker_certificate: data?.broker_certificate ? JSON.parse(data?.broker_certificate) : [],
    supervisor_name: data?.supervisor?.full_name || '',
    request_processed_at: moment(data?.request_processed_at).format('DD/MM/YYYY') || '',
    processing_status: getStatusBrokerObject(data?.processing_status),
    supervisor_id: data?.supervisor_id || null,
  }
}

export const parseFormDataBroker = (data: any) => {

  return {
    id: data?.id || null,
    // province_id: data?.province_id || null,
    // district_id: data?.district_id || null,
    // ward_id: data?.ward_id || null,
    regions: data?.regions?.length > 0 && data.regions.map(item => item.region),
    point: data?.point || 0,
    address: data?.address || '',
    manager_code: data?.manager_code || null,
    business_type: isObject(data.business_type) ? data.business_type.code : data.business_type,
    broker_level: isObject(data.broker_level) ? data.broker_level.code : data.broker_level,
    tax_id: data?.tax_id || '',
    bank_name: data?.bank_name || '',
    bank_account_name: data?.bank_account_name || '',
    bank_account_number: data?.bank_account_number || '',
    bio: data?.bio || '',
    broker_certificate: data?.broker_certificate || [],
    zalo: data?.zalo || '',
    facebook: data?.facebook || '',
    //api chưa có
    email: data?.email || '',
    phone_number: data?.phone_number || '',
    profile_image: data?.profile_image || '',
    full_name: data?.full_name || '',
    manager_id: data?.manager_id || null,
  }
}
